import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_user_update_permissions = createAsyncThunkSafe<void, DTO__workspace_user>(
  ENUM__network_event_client_to_server.WORKSPACE_USER_UPDATE_PERMISSIONS,
  async (user): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_USER_UPDATE_PERMISSIONS, user);
  },
);

export function init_remote_workspace_user_update_permissions(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_user_update_permissions.pending, (state, action) => {})
    .addCase(remote_workspace_user_update_permissions.rejected, (state, action) => {})
    .addCase(remote_workspace_user_update_permissions.fulfilled, (state, action: PayloadAction) => {});
}
